import React from "react"
import PropTypes from "prop-types"
import { StepIcon, StepLine } from "../rendez-vous-styled"
import {
  indicatorLine,
  stepWrapper,
  stepIcon,
  stepIndicator,
} from "./step-indicator.module.scss"

export const StepIndicator = ({ step }) => {
  return (
    <section className={stepIndicator}>
      <div className={stepWrapper}>
        <StepIcon active={step === 2} isDone={step > 2} className={stepIcon}>
          1
        </StepIcon>
      </div>
      <StepLine
        active={step === 3}
        isDone={step > 2}
        className={indicatorLine}
      ></StepLine>
      <div className={stepWrapper}>
        <StepIcon active={step === 3} isDone={step > 3} className={stepIcon}>
          2
        </StepIcon>
      </div>
      <StepLine
        active={step === 4}
        isDone={step > 3}
        className={indicatorLine}
      ></StepLine>
      <div className={stepWrapper}>
        <StepIcon active={step === 4} isDone={step > 4} className={stepIcon}>
          3
        </StepIcon>
      </div>
      <StepLine
        active={step === 5}
        isDone={step > 4}
        className={indicatorLine}
      ></StepLine>
      <div className={stepWrapper}>
        <StepIcon active={step === 5} className={stepIcon}>
          4
        </StepIcon>
      </div>
    </section>
  )
}

StepIndicator.propTypes = {
  step: PropTypes.number,
}
